import { Component, inject, input } from '@angular/core';

import { FlowItemModel, FlowItemViewModel } from '../../../shared/models/FlowItemModel';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule, DatePipe } from '@angular/common';
import moment from 'moment';
import { ReportOverallGradesComponent } from "../report-overall-grades/report-overall-grades.component";
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ReportDetailsDialogComponent } from '../report-details-dialog/report-details-dialog.component';
import { Globals } from '../../../shared/models/globals';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-report-tight',
  imports: [CommonModule, MatIconModule, DatePipe, ReportOverallGradesComponent, RouterModule],
  templateUrl: './report-tight.component.html',
  styleUrl: './report-tight.component.css'
})
export class ReportTightComponent {

  report = input<FlowItemModel>();
  readonly dialog = inject(MatDialog);

  _globals = inject(Globals);


    getTimeAgo(){
      
      var language = localStorage.getItem("language");
      //console.log("ReportTightComponent getTimeAgo", language?.substring(0,2));
      moment.locale(language?.substring(0,2) ?? 'en');
      return moment(this.report()?.DateCreated).fromNow();
    }

    openReportDetails() {
    const dialogRef = this.dialog.open(ReportDetailsDialogComponent, {
      width: '100vw',
      maxWidth: '450px',
      height: '100dvh',
      maxHeight: '100dvh',
      
       panelClass: 'side-dialog',
      position: {
        right: '0'
      },
      data: {
        ReportId: this.report()?.ReportId,
        CanEdit: this.report()?.IsCreatedByCurrentUser       
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log(`Dialog result: ${result}`);
    });
    }

    setClass(){
      // console.log("setClass",
      //   this.report()?.TotalQuality
      // );
      return {            
        "greenborder ": (this.report()?.TotalQuality??0) >3,
        "lightgreenborder ": this.report()?.TotalQuality==3,
        "yellowborder ": this.report()?.TotalQuality==2,
        "redborder ": this.report()?.TotalQuality==1,
      };
  }

}
